/*
 * fn: getTypeDistributionData
 *
 * Gets helpers for the Type Distribution graph
 *
 */
import { type PageType } from '@/defs/page'
import { slugify } from '@/utils/commonUtil'

type Props = {
  typeDistribution?: NonNullable<PageType['charts']>['typeDistribution']
}

export const getTypeDistributionData = ({ typeDistribution }: Props) => {
  const slices = [...(typeDistribution || [])].reverse().flatMap(({ label, value }) => {
    const slug = slugify(label || '')

    if (!slug) return []

    return [{ fill: `var(--${slug}-fill, #fff)`, label: label || '', value: value || 0 }]
  })

  const countAll = slices.reduce((acc, s) => acc + s.value, 0)

  return { countAll, slices }
}
